"use strict";
/**
 * Created by Ning Jiang on 6/20/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetLineEvent = void 0;
class BetLineEvent {
}
BetLineEvent.SHOW_STATIC_BET_LINE = "betLineEvent_showStaticBetLine";
BetLineEvent.HIDE_STATIC_BET_LINE = "betLineEvent_hideStaticBetLine";
BetLineEvent.SHOW_WIN_BET_LINE = "betLineEvent_showWinBetLine";
BetLineEvent.HIDE_WIN_BET_LINE = "betLineEvent_hideWinBetLine";
BetLineEvent.HIDE_ALL_BET_LINES = "betLineEvent_hideAllBetLines";
BetLineEvent.SET_ENABLED = "betLineEvent_setEnabled";
exports.BetLineEvent = BetLineEvent;
//# sourceMappingURL=BetLineEvent.js.map